module.exports = __webpack_public_path__ + "media/images/teams/FIORENTINA-56fc049da8a992cce4c8dc1146e986ea.png";